<!--
* UI Name: SOAP API
* Modify Date: 2022/07/18
-->
<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4" style="height: 595px; overflow: auto">
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.soapApi') }}
            </font>
            <v-text-field
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Server address</v-label>
            <v-text-field
              v-model="formData.host"
              :rules="[validationUtils.required, validationUtils.min(8), validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label>Security</v-label>
            <v-select
              v-model="formData.security"
              :items="securities"
              solo
              :menu-props="{ offsetY: true }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="h-2"></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="h-2"></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Method</v-label>
            <v-select
              v-model="formData.method"
              :items="methodHttp"
              solo
              :rules="[validationUtils.required]"
              :menu-props="{ offsetY: true }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label>Path</v-label>
            <v-text-field v-model="formData.path" solo :disabled="!$auth.manage"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="h-2"></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="6" class="pr-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.exeInterval') }}</v-label
                >
                <v-text-field
                  v-model="formData.interval"
                  type="number"
                  :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="intervalDefault"
                  :items="intervals"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  return-object
                  class="select-interval"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label>Temp Path</v-label>
            <v-text-field
              v-model="formData.temp_path"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="px-4 pb-2">
            <v-row class="ml-0 mr-0 d-block">
              <v-col lg="11" class="pa-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>HTTP Headers</v-label>
              </v-col>
              <v-tooltip top :disabled="httpHeaders.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="1" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('HTTP Headers')"
                        :disabled="!$auth.manage || httpHeaders.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form
              ref="formHttpHeaders"
              class="dialog-content pr-0 mb-2"
              v-on:submit.prevent="doNoThing"
            >
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, index) in httpHeaders"
                :key="item.id"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'HTTP_' + item.id"
                          solo
                          hide-details
                          v-model="item.keyPattern"
                          @keyup.native="validatePattern('HTTP Headers', item)"
                          :rules="[validationUtils.required]"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'HTTP_' + item.id + '_' + item.id"
                    solo
                    hide-details
                    v-model="item.valuePattern"
                    :rules="[validationUtils.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('HTTP Headers', index)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" md="12" class="px-4">
            <v-row class="ml-0 mr-0 d-block">
              <v-col lg="11" class="pa-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>SOAP</v-label>
              </v-col>
              <v-tooltip top :disabled="soapList.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="1" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('SOAP')"
                        :disabled="!$auth.manage || soapList.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form ref="soapList" class="dialog-content pr-0 mb-2">
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, index) in soapList"
                :key="item.id"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'SOAP_' + item.id"
                          solo
                          hide-details
                          v-model="item.keyPattern"
                          @keyup.native="validatePattern('SOAP', item)"
                          :rules="[validationUtils.required]"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'SOAP_' + item.id + '_' + item.id"
                    solo
                    hide-details
                    v-model="item.valuePattern"
                    :rules="[validationUtils.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('SOAP', index)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" :class="['px-4', callbackList.length > 0 ? 'mb-0' : 'mb-4']">
            <v-row class="mx-0 my-2 d-flex">
              <v-col lg="2" class="d-flex align-center pa-0">
                <v-label>Callbacks</v-label>
                <v-tooltip top :disabled="callbackList.length < maxPattern">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip ml-2">
                      <v-col lg="1" class="pa-0 mb-1 text-right">
                        <v-icon
                          dense
                          @click="addPattern('Callbacks')"
                          :disabled="!$auth.manage || callbackList.length > maxPattern - 1"
                        >
                          mdi-plus
                        </v-icon>
                      </v-col>
                    </div>
                  </template>
                  <span v-html="$t('lbl.communications.validMaxPattern')"></span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-form
              ref="callbacks"
              class="dialog-content pr-0 mb-2"
              style="min-height: 400px"
              v-if="callbackList.length > 0"
            >
              <v-row
                class="ml-0 mr-0 mb-2 edi-identification callbacks-soap"
                v-for="(item, index) in callbackList"
                :key="item.id"
                style="height: auto"
              >
                <v-col cols="12" md="12" class="text-right">
                  <v-btn small text icon @click="removePattern('Callbacks', index)">
                    <icon-svg iconName="close" />
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="mt-5">
                  <v-row>
                    <v-col cols="12" md="8" class="pa-0">
                      <v-tooltip top :disabled="!item.isValidatePattern">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-select
                              :ref="'CALL_' + item.id"
                              v-model="item.callbackLabel"
                              :label="callbackLabel"
                              :items="callbackMethodList"
                              @change="validatePattern('Callbacks', item)"
                              solo
                              :menu-props="{ offsetY: true }"
                              :disabled="!$auth.manage"
                              :rules="[validationUtils.required]"
                            ></v-select>
                          </div>
                        </template>
                        <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                      </v-tooltip>
                    </v-col>
                    <!-- <v-col cols="12" md="1" class="pa-0 mt-2 text-right">
                      <v-icon
                        dense
                        @click="removePattern('Callbacks', index)"
                      >
                        mdi-minus
                      </v-icon>
                    </v-col> -->
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="pl-0 pr-4">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Method</v-label>
                  <v-select
                    v-model="item.methodCallback"
                    :items="methodCallbacks"
                    solo
                    :menu-props="{ offsetY: true }"
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="12" class="pl-0 pr-4 mb-2">
                  <v-row class="ml-0 mr-0 d-block">
                    <v-col lg="11" class="pa-0">
                      <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Headers</v-label>
                    </v-col>
                    <v-tooltip top :disabled="headersList.length > maxPattern - 1">
                      <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-tooltip">
                          <v-col lg="1" class="pa-0 mb-1 text-right">
                            <v-icon
                              dense
                              @click="addPattern('Headers', index)"
                              :disabled="!$auth.manage || headersList.length > maxPattern - 1"
                            >
                              mdi-plus
                            </v-icon>
                          </v-col>
                        </div>
                      </template>
                      <span v-html="$t('lbl.communications.validMaxPattern')"></span>
                    </v-tooltip>
                  </v-row>
                  <v-form ref="formHeaders" class="dialog-content pr-0 mb-2">
                    <v-row
                      class="ml-0 mr-0 mb-4 edi-identification"
                      v-for="(item, indexHeaders) in callbackList[index].headersList"
                      :key="indexHeaders"
                    >
                      <v-col cols="12" md="4" class="pa-0">
                        <v-tooltip top :disabled="!item.isValidatePattern">
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                :ref="'PTTN_' + index + '_' + indexHeaders"
                                solo
                                hide-details
                                v-model="item.keyPattern"
                                @keyup.native="validatePattern('Headers', item, index)"
                                :rules="[validationUtils.required]"
                              ></v-text-field>
                            </div>
                          </template>
                          <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" md="7" class="pa-0 pl-2">
                        <v-text-field
                          :ref="'PTTN_' + index + '_' + indexHeaders + '_' + indexHeaders"
                          solo
                          hide-details
                          v-model="item.valuePattern"
                          :rules="[validationUtils.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                        <v-icon dense @click="removePattern('Headers', index, indexHeaders)">
                          mdi-minus
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col cols="12" md="12" class="pl-0 pr-4">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Body</v-label>
                  <v-textarea
                    solo
                    v-model="item.callbackBody"
                    :rules="[validationUtils.required]"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6" class="pl-0 pr-4">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>URI</v-label>
                  <v-text-field
                    v-model="item.uri"
                    solo
                    :rules="[validationUtils.required]"
                    :disabled="!$auth.manage"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pl-0 pr-4">
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-label
                        ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Callback
                        Response</v-label
                      >
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-text-field
                        :ref="'CALLRES_' + item.id"
                        v-model="item.responseAs[0].keyPattern"
                        solo
                        :disabled="!$auth.manage"
                        :rules="[validationUtils.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        :ref="'CALLRES_' + item.id + '_' + item.id"
                        v-model="item.responseAs[0].valuePattern"
                        solo
                        :disabled="!$auth.manage"
                        :rules="[validationUtils.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  props: {
    item: {
      type: Object,
    },
  },

  data() {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      methodHttp: [
        { value: 'POST', text: 'POST' },
        { value: 'GET', text: 'GET' },
      ],
      methodCallbacks: [
        { value: 'GET', text: 'GET' },
        { value: 'PUT', text: 'PUT' },
        { value: 'DELETE', text: 'GET' },
        { value: 'POST', text: 'POST' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      httpHeaders: [],
      soapList: [],
      callbackList: [],
      headersList: [],
      setPattern: new Set(),
      // isValidatePattern: false,
      httpHeaderType: [],
      maxPattern: 5,
      isDuplicatePattern: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      callbackMethodList: [],
      callbackBody: '',
      responseAs: {},
      callbackLabel: '',
    };
  },

  created() {
    this.formData = Object.assign({}, this.getInitData(), this.item);
    if (this.formData.action == 'add') {
      this.formData.httpHeaders = {
        'Content-Type': 'text/xml',
        encoding: 'utf-8',
        SoapAction: 'askBusiness',
      };
      Object.entries(this.formData.httpHeaders).forEach(([key, value], index) => {
        this.httpHeaders.push({
          id: index,
          keyPattern: key,
          valuePattern: value,
          isValidatePattern: false,
        });
        this.setPattern.add(key);
      });
      this.formData.soap = {
        version: '1.1',
        messageTemplate:
          '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ntt="http://nttdataspgw.jp/"><soapenv:Header/><soapenv:Body><ntt:askBusiness><arg0>${spId}</arg0><arg1>${spPw}</arg1><arg2>${message}</arg2><arg3>${msgType}</arg3></ntt:askBusiness></soapenv:Body> </soapenv:Envelope>',
        responseAs: { naccsedi: '//return/naccsedi', rtncd: '//return/rtncd' },
      };
      this.formData.soap.responseAs = JSON.stringify(this.formData.soap.responseAs);
      Object.entries(this.formData.soap).forEach(([key, value], index) => {
        this.soapList.push({
          id: index,
          keyPattern: key,
          valuePattern: value,
        });
      });
    }
    if (this.formData.action == 'edit' || this.formData.action == 'copy') {
      // this.headersList = {
      //   "Content-Type": "application/json",
      //   Authorization: "Bearer ${token}",
      // };
      Object.entries(this.formData.httpHeaders).forEach(([key, value], index) => {
        let data = key.split('_|_');
        this.httpHeaders.push({
          id: data[1],
          keyPattern: data[0],

          valuePattern: value,
        });
      });

      this.httpHeaders.sort(function(a, b) {
        return b.id > a.id ? -1 : 1;
      });

      Object.entries(this.formData.soap).forEach(([key, value], index) => {
        let data = key.split('_|_');
        if (data[0] == 'responseAs') {
          value = JSON.stringify(value);
        }
        this.soapList.push({
          id: data[1],
          keyPattern: data[0],
          valuePattern: value,
        });
      });

      this.soapList.sort(function(a, b) {
        return b.id > a.id ? -1 : 1;
      });

      this.callbackList = [];
      Object.entries(this.formData.callbacks).forEach(([key, value], index) => {
        let callbackValue = {};
        callbackValue.id = index;
        callbackValue.callbackLabel = key;
        callbackValue.callbackBody = value.body;
        callbackValue.headersList = [];
        Object.entries(value.headers).forEach(([key, value], index) => {
          callbackValue.headersList.push({
            id: index,
            keyPattern: key,
            valuePattern: value,
          });
        });
        callbackValue.responseAs = [];
        Object.entries(value.responseAs).forEach(([key, value], index) => {
          callbackValue.responseAs.push({
            id: index,
            keyPattern: key,
            valuePattern: value,
          });
        });
        callbackValue.uri = value.uri;
        callbackValue.methodCallback = value.method;
        this.callbackList.push(callbackValue);
      });
    }
    if (!this.formData.interval) {
      this.formData.interval = '30';
    }
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    if (this.item.intervalType) {
      this.intervalDefault = this.intervals.filter(
        (item) => item.value === this.item.intervalType,
      )[0];
    }
    this.getListComboFilenamePattern();
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    async save() {
      if (this.isDuplicatePattern) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        this.checkDialogInfo = this.$t('msg.communications.validDuplicatePattern');
        return -1;
      }
      if (this.httpHeaders.length == 0) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        this.checkDialogInfo = this.$t('msg.communications.validEmptyHttpHeaders');
        return -1;
      }
      if (this.soapList.length == 0) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        this.checkDialogInfo = this.$t('msg.communications.validEmptySoap');
        return -1;
      }
      if (this.callbackList.length > 0) {
        let validResult = this.$refs.callbacks.validate();
        if (!validResult) return;
      }
      let indexValidPatternHttpHeaders = this.httpHeaders.findIndex(
        (e) => e.keyPattern === '' || e.valuePattern === '',
      );
      if (indexValidPatternHttpHeaders > -1) {
        let itemPattern = this.httpHeaders[indexValidPatternHttpHeaders];
        this.$refs[
          `HTTP_${itemPattern.id}${itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id}`
        ][0].focus();
        return -1;
      }
      this.httpHeaders.map((e) => (e.keyPattern += '_|_' + e.id));
      this.formData.httpHeaders = this.convertArrayObjectToJson(this.httpHeaders);
      let indexValidPatternSoapList = this.soapList.findIndex(
        (e) => e.keyPattern === '' || e.valuePattern === '',
      );
      if (indexValidPatternSoapList > -1) {
        let itemPattern = this.soapList[indexValidPatternSoapList];
        this.$refs[
          `SOAP_${itemPattern.id}${itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id}`
        ][0].focus();
        return -1;
      }
      for (const soap of this.soapList) {
        if (soap.keyPattern == 'responseAs') {
          soap.valuePattern = JSON.parse(soap.valuePattern);
        }
      }
      this.soapList.map((e) => (e.keyPattern += '_|_' + e.id));
      this.formData.soap = this.convertArrayObjectToJson(this.soapList);
      for (let i = 0; i < this.callbackList.length; i++) {
        let item = this.callbackList[i];
        if (item.headersList.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyHeaders');
          return -1;
        }
        let indexValidPatternHeaders = item.headersList.findIndex(
          (e) => e.keyPattern === '' || e.valuePattern === '',
        );
        if (indexValidPatternHeaders > -1) {
          let itemPattern = item.headersList[indexValidPatternHeaders];
          this.$refs[
            `PTTN_${i}_${itemPattern.id}${
              itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id
            }`
          ][0].focus();
          return -1;
        }
      }
      // Get JSON Callbacks
      let callbacks = [];
      for (let i = 0; i < this.callbackList.length; i++) {
        let callback = {};
        let item = this.callbackList[i];
        callback = {
          method: item.methodCallback,
          headers: this.convertArrayObjectToJson(item.headersList),
          body: item.callbackBody,
          uri: item.uri,
          responseAs: this.convertArrayObjectToJson(item.responseAs),
        };
        callbacks.push({
          id: i,
          keyPattern: item.callbackLabel,
          valuePattern: callback,
        });
      }
      this.formData.callbacks = this.convertArrayObjectToJson(callbacks);
      this.formData.intervalType = this.intervalDefault.value;
      if (this.formData.action == 'edit') {
        let editedData = getEditData(this.formData, this.loadFormData);
        editedData.id = this.formData.id;
        if (editedData.name === undefined) {
          editedData.name = this.formData.name;
        }

        if (this.intervalDefault.value) {
          editedData.intervalType = this.intervalDefault.value;
        }

        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    convertArrayObjectToJson(listObject) {
      let jsonFormat;
      if (listObject.length > 0) {
        jsonFormat = listObject.reduce(
          (obj, item) => Object.assign(obj, { [item.keyPattern]: item.valuePattern }),
          {},
        );
      } else {
        jsonFormat = {};
      }
      return jsonFormat;
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        security: '',
        userid: '',
        password: '',
        showpassword: true,
        path: '',
        interval: '',
        type: 'SOAP',
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != "showpassword" && prop != "type") {
    //       if (this.formData[prop].trim() != "") {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      if (this.item.type == 'FTPS' || this.item.type == 'FTP') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            // 05/31/2021 203737 SPKA-127 issue 76 Change minimum interval value for "Seconds" from 30 to 10. (validation allow 10~59 seconds)
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    getListComboFilenamePattern() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P11' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.callbackMethodList.push({
            text: item.text,
            value: item.value,
          });
        });
        this.getHttpHeaderType();
      });
    },
    addPattern(status, indexCallback) {
      let index = 0;
      switch (status) {
        case 'HTTP Headers':
          index =
            this.httpHeaders.length > 0 ? this.httpHeaders[this.httpHeaders.length - 1].id + 1 : 1;
          this.httpHeaders.push({
            id: index,
            keyPattern: '',
            valuePattern: '',
            isValidatePattern: false,
          });
          break;
        case 'SOAP':
          index = this.soapList.length > 0 ? this.soapList[this.soapList.length - 1].id + 1 : 1;
          this.soapList.push({
            id: index,
            keyPattern: '',
            valuePattern: '',
            isValidatePattern: false,
          });
          break;
        case 'Callbacks': {
          index =
            this.callbackList.length > 0
              ? this.callbackList[this.callbackList.length - 1].id + 1
              : 1;
          let callbackHeaders = [];
          let headersList = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ${token}',
          };
          Object.entries(headersList).forEach(([key, value], index) => {
            callbackHeaders.push({
              id: index,
              keyPattern: key,
              valuePattern: value,
            });
          });
          this.callbackList.push({
            id: index,
            callbackLabel: '',
            methodCallback: '',
            callbackBody:
              '{"message":{"fileName":"","fileContent":"{\\"naccsedi\\":\\"${naccsedi}\\", \\"rtncd\\":\\"${rtncd}\\"}"}}',
            uri: '',
            responseAs: [
              {
                id: 0,
                keyPattern: '',
                valuePattern: '',
              },
            ],
            isValidatePattern: false,
            headersList: callbackHeaders,
          });
          break;
        }
        case 'Headers':
          index =
            this.callbackList[indexCallback].headersList.length > 0
              ? this.callbackList[indexCallback].headersList[
                  this.callbackList[indexCallback].headersList.length - 1
                ].id + 1
              : 1;
          this.callbackList[indexCallback].headersList.push({
            id: index,
            keyPattern: '',
            valuePattern: '',
            isValidatePattern: false,
          });
          break;
        default:
          break;
      }
    },
    removePattern(status, index, indexHeaders) {
      switch (status) {
        case 'HTTP Headers':
          this.httpHeaders.splice(index, 1);
          this.resetSetPattern(status);
          break;
        case 'SOAP':
          this.soapList.splice(index, 1);
          this.resetSetPattern(status);
          break;
        case 'Callbacks':
          this.callbackList.splice(index, 1);
          this.resetSetPattern(status);
          break;
        case 'Headers':
          this.callbackList[index].headersList.splice(indexHeaders, 1);
          this.resetSetPattern(status, index);
          break;
        default:
          break;
      }
    },
    doNoThing() {
      console.log('Skip Enter');
    },
    validatePattern(status, itemChange, index) {
      let indexValid;
      switch (status) {
        case 'HTTP Headers':
          indexValid = this.httpHeaders.findIndex((e) => e.id === itemChange.id);
          if (this.setPattern.has(itemChange.keyPattern)) {
            this.isDuplicatePattern = true;
            this.httpHeaders[indexValid].isValidatePattern = true;
          } else {
            this.isDuplicatePattern = false;
            this.httpHeaders[indexValid].isValidatePattern = false;
          }
          this.resetSetPattern('HTTP Headers');
          break;
        case 'SOAP':
          indexValid = this.soapList.findIndex((e) => e.id === itemChange.id);
          if (this.setPattern.has(itemChange.keyPattern)) {
            this.isDuplicatePattern = true;
            this.soapList[indexValid].isValidatePattern = true;
          } else {
            this.isDuplicatePattern = false;
            this.soapList[indexValid].isValidatePattern = false;
          }
          this.resetSetPattern('SOAP');
          break;
        case 'Callbacks':
          indexValid = this.callbackList.findIndex((e) => e.id === itemChange.id);
          if (this.setPattern.has(itemChange.callbackLabel)) {
            this.isDuplicatePattern = true;
            this.callbackList[indexValid].isValidatePattern = true;
          } else {
            this.isDuplicatePattern = false;
            this.callbackList[indexValid].isValidatePattern = false;
          }
          this.resetSetPattern('Callbacks');
          break;
        case 'Headers':
          indexValid = this.callbackList[index].headersList.findIndex(
            (e) => e.id === itemChange.id,
          );
          if (this.setPattern.has(itemChange.keyPattern)) {
            this.isDuplicatePattern = true;
            this.callbackList[index].headersList[indexValid].isValidatePattern = true;
          } else {
            this.isDuplicatePattern = false;
            this.callbackList[index].headersList[indexValid].isValidatePattern = false;
          }
          this.resetSetPattern('Headers', index);
          break;
        default:
          break;
      }
    },
    getHttpHeaderType() {
      this.callbackMethodList.map((item) => {
        this.httpHeaderType.push(item.value);
      });
      Object.keys(this.formData).map((item, index) => {
        if (this.httpHeaderType.includes(item) && this.formData[item]) {
          let obj = {
            id: index + 1,
            keyPattern: item,
            valuePattern: this.formData[item],
            isValidatePattern: false,
          };
          this.httpHeaders.push(obj);
          this.setPattern.add(item);
        }
      });
    },
    resetSetPattern(status, index) {
      this.setPattern.clear();
      switch (status) {
        case 'HTTP Headers':
          this.httpHeaders.map((item) => {
            if (item.keyPattern !== '') {
              this.setPattern.add(item.keyPattern);
            }
          });
          break;
        case 'SOAP':
          this.soapList.map((item) => {
            if (item.keyPattern !== '') {
              this.setPattern.add(item.keyPattern);
            }
          });
          break;
        case 'Callbacks':
          this.callbackList.map((item) => {
            if (item.callbackLabel !== '') {
              this.setPattern.add(item.callbackLabel);
            }
          });
          break;
        case 'Headers':
          this.callbackList[index].headersList.map((item) => {
            if (item.keyPattern !== '') {
              this.setPattern.add(item.keyPattern);
            }
          });
          break;
        default:
          break;
      }
    },
    closeDialog() {
      this.$refs.DuplicatePatternDialog.dialog = false;
    },
  },
};
</script>
<style>
.communication-patterns {
  min-height: 0;
  max-height: 70px;
  overflow-y: auto;
}
.v-dialog-1 .v-textarea > .v-input__control > .v-input__slot {
  min-height: 100px !important;
}
.callbacks-soap {
  padding: 16px;
  border: 3px solid #797b81;
}
</style>
